import { createAction } from 'redux-actions';

import { RESET_TASK_OVERVIEW_CONTEXT_USER, SET_TASK_OVERVIEW_CONTEXT_USER } from './actionTypes';

export const setTaskOverviewUserContext = createAction(SET_TASK_OVERVIEW_CONTEXT_USER);

export const resetTaskOverviewUserContext = createAction(RESET_TASK_OVERVIEW_CONTEXT_USER);
